import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { ConfigService } from '../shared/config.service';
import { BaseService } from '../shared/base.service';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends BaseService {

  newPartner: any;
  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
  }

  GetAllExportData(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token
      })
    };
    let url = '';
    url = this.configService.resourceApiURI + '/partner/DownloadCsvData';
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  GetRegisterByPartnerUser(token: string, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/partner/GetRegisterByPartnerUser/'+ id, httpOptions).pipe(catchError(this.handleError));
  }

GetViaFirmaLink(token: string, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text',
        Authorization: token,
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/partner/GetViaFirmaLink/'+id, httpOptions,).pipe(catchError(this.handleError));
  }

  ContractSign(token: string, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text',
        Authorization: token,
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/partner/ContractSign/' + id, httpOptions,).pipe(catchError(this.handleError));
  }

  DisablePartner(token: string, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text',
        Authorization: token,
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/partner/disablePartner/' + id, httpOptions,).pipe(catchError(this.handleError));
  }

  CheckPartnerStatus(token: string, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text',
        Authorization: token,
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/partner/CheckPartnerStatus/' + id, httpOptions,).pipe(catchError(this.handleError));
  }

  UpdatePartnerToSign(token: string, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token
      })
    };

    return this.http.put(this.configService.resourceApiURI + '/partner/UpdatePartnerToSign', data, httpOptions).pipe(catchError(this.handleError));
  }

  InsertPartner(token: string, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token
      })
    };

    return this.http.post(this.configService.resourceApiURI + '/partner', data, httpOptions).pipe(catchError(this.handleError));
  }

  UpdateComercial(token: string, partner: any, comercial: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/partner/UpdateComercial/' +partner+'/'+comercial, httpOptions).pipe(catchError(this.handleError));
  }

  GetListD2D(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text',
        Authorization: token,
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/d2d/D2D', httpOptions,).pipe(catchError(this.handleError));
  }

  GetListMpaAgent(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text',
        Authorization: token,
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/d2d/MpaAgent', httpOptions,).pipe(catchError(this.handleError));
  }

  GetListMultisede(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text',
        Authorization: token,
      })
    };

    return this.http.get(this.configService.resourceApiURI + '/d2d/Multisede', httpOptions,).pipe(catchError(this.handleError));
  }

  public upload(token: string, file: Blob) {
    const formData = new FormData();
    formData.append('file', file);
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: token
      })
    };

    return this.http.post(this.configService.resourceApiURI + '/partner/UpdateComercialFile', formData, httpOptions).pipe(catchError(this.handleError));
  }

}
